import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface BeforePhotoProps {
  src: string;
  alt: string;
}

export default function BeforePhoto({ src, alt }: BeforePhotoProps) {
  return (
    <div className="relative h-full min-h-[300px] sm:min-h-[400px] rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl">
      <AppImage
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
      />
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900/90 via-slate-900/50 to-transparent p-4 sm:p-6">
        <span className="inline-block px-3 py-1 bg-muted/80 backdrop-blur-sm rounded-full text-xs font-medium text-foreground">
          Before Transformation
        </span>
      </div>
    </div>
  );
}